import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.site_page_type_ */
export type SitePageTypeId = string & { __brand: 'SitePageTypeId' }

/** Represents the table public.site_page_type_ */
export default interface SitePageTypeTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<SitePageTypeId, SitePageTypeId, SitePageTypeId>

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type SitePageType = Selectable<SitePageTypeTable>

export type SitePageTypeInitializer = Insertable<SitePageTypeTable>

export type SitePageTypeMutator = Updateable<SitePageTypeTable>

export const sitePageTypeId = z.string() as unknown as z.Schema<SitePageTypeId>

export const sitePageType = z.object({
  id: sitePageTypeId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<SitePageType>

export const sitePageTypeInitializer = z.object({
  id: sitePageTypeId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SitePageTypeInitializer>

export const sitePageTypeMutator = z.object({
  id: sitePageTypeId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SitePageTypeMutator>
